// Open search bar
document.querySelectorAll('.search-opener').forEach(search=>{
    search.addEventListener('click', function() {
  const headerSearch = document.querySelector('.header-search');
  if (headerSearch) {
    headerSearch.classList.add('header-search__opened');
    document.body.style.overflow = 'hidden'; 
  }
});
})


//close search bar
document.addEventListener('click', function(e) {
  const clearBtn = e.target.closest('.ps-clear');
  if (clearBtn) {
    const headerSearch = document.querySelector('.header-search');
    if (headerSearch) {
      headerSearch.classList.remove('header-search__opened');
      document.body.style.overflow = ''; 
    }
  }
});


(function () {
  const root = document.querySelector("[data-predictive-search]");
  if (!root) return;

  const form = root.querySelector("#ps-form");
  const input = root.querySelector("#ps-input");
  const popover = root.querySelector("#ps-popover");
  const clearBtn = root.querySelector(".ps-clear");

  const baseUrl = input?.dataset?.predictiveSearchUrl || "/search/suggest.json";
  const sectionId = input?.dataset?.sectionId || "predictive-search";
  const MIN_CHARS = 2;

  let activeIndex = -1; 
  let currentOptions = [];

  const debounce = (fn, delay = 180) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  const showPopover = () => {
    popover.hidden = false;
    input.setAttribute("aria-expanded", "true");
    clearBtn.hidden = !input.value?.length;
  };

  const hidePopover = () => {
    popover.hidden = true;
    input.setAttribute("aria-expanded", "false");
    activeIndex = -1;
    currentOptions = [];
  };

  const setActive = (index) => {
    if (!currentOptions.length) return;
    currentOptions.forEach((el) => {
      el.classList.remove("is-active");
      el.setAttribute("aria-selected", "false");
    });
    if (index >= 0 && index < currentOptions.length) {
      currentOptions[index].classList.add("is-active");
      currentOptions[index].setAttribute("aria-selected", "true");
      currentOptions[index].scrollIntoView({ block: "nearest" });
    }
    activeIndex = index;
  };

  const buildUrl = (q) => {
    const params = new URLSearchParams();
    params.set("q", q);
    // query products + collections,
    params.set("resources[type]", "product,collection");
    params.set("resources[limit]", "12");
    params.set("resources[limit_scope]", "each");   // limit is 12 per type
    params.set("section_id", sectionId);
    return `${baseUrl}?${params.toString()}`;
  };

  const render = (html) => {
    popover.innerHTML = html;
    currentOptions = Array.from(popover.querySelectorAll('[role="option"]'));
    showPopover();
  };

  const handleInput = async () => {
    const q = input.value.trim();
    if (q.length < MIN_CHARS) {
      hidePopover();
      return;
    }
    try {
      const res = await fetch(buildUrl(q), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const html = await res.text();
      console.log('html', html)
      
      render(html);
      setActive(-1);
    } catch (e) {
      hidePopover();
      // optionally: console.error(e);
    }
  };

  const onKeyDown = (e) => {
    if (popover.hidden) return;
    if (!currentOptions.length) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActive(Math.min(activeIndex + 1, currentOptions.length - 1));
        break;
      case "ArrowUp":
        e.preventDefault();
        setActive(Math.max(activeIndex - 1, 0));
        break;
      case "Enter":
        if (activeIndex >= 0 && currentOptions[activeIndex]) {
          e.preventDefault();
          const link = currentOptions[activeIndex].querySelector("a[href]");
          if (link) window.location.href = link.href;
        }
        break;
      case "Escape":
        hidePopover();
        input.blur();
        break;
    }
  };

  // Hover/mouse selection
  popover.addEventListener("mousemove", (e) => {
    const item = e.target.closest('[role="option"]');
    if (!item) return;
    const idx = currentOptions.indexOf(item);
    if (idx >= 0) setActive(idx);
  });
  popover.addEventListener("mouseleave", () => setActive(-1));

  // Click selects
  popover.addEventListener("click", (e) => {
    const link = e.target.closest("a[href]");
    if (link) {
      e.preventDefault();
      window.location.href = link.href;
    }
  });

  // Outside click closes
  document.addEventListener("click", (e) => {
    if (!root.contains(e.target)) hidePopover();
  });

  // Clear button
  clearBtn.addEventListener("click", () => {
    input.value = "";
    hidePopover();    
    const headerSearch =
      root.closest(".header-search") ||
      document.querySelector(".header-search");
    if (headerSearch) {
      headerSearch.classList.remove("is-open");
      document
        .querySelectorAll(".js-search-toggle")
        .forEach((el) => (el.style.display = ""));
    }
  });

  // Submit fallback -> full search
  form.addEventListener("submit", (e) => {    
    hidePopover();
  });

  input.addEventListener("input", debounce(handleInput, 160));
  input.addEventListener("focus", () => {
    if (input.value.trim().length >= MIN_CHARS && popover.innerHTML.trim())
      showPopover();
  });
  input.addEventListener("keydown", onKeyDown);
})();


